import { LinearProgress, Box } from "@material-ui/core";

const FetchingProgress = ({ isFetching, pad = true }) => {
  return isFetching ? <LinearProgress /> : <Box height={pad ? 4 : 0} />;
};

export default FetchingProgress;
